var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var Gradient = /*#__PURE__*/function () {
  "use strict";

  function Gradient() {
    var _this = this;

    var gradients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var maxNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var colors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['', ''];
    var intervals = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, Gradient);

    var setColors = function setColors(props) {
      if (props.length < 2) {
        throw new Error("setGradient should have more than ".concat(props.length, " color"));
      } else {
        var increment = maxNum / (props.length - 1);
        var firstGradient = new GradientColor();
        var lower = 0;
        var upper = 0 + increment;
        firstGradient.setGradient(props[0], props[1]);
        firstGradient.setMidpoint(lower, upper);
        gradients = [firstGradient];
        intervals = [{
          lower: lower,
          upper: upper
        }];

        for (var i = 1; i < props.length - 1; i++) {
          var gradientColor = new GradientColor();

          var _lower = 0 + increment * i;

          var _upper = 0 + increment * (i + 1);

          gradientColor.setGradient(props[i], props[i + 1]);
          gradientColor.setMidpoint(_lower, _upper);
          gradients[i] = gradientColor;
          intervals[i] = {
            lower: _lower,
            upper: _upper
          };
        }

        colors = props;
      }
    };

    this.setGradient = function () {
      for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }

      setColors(props);
      return _this;
    };

    this.getArray = function () {
      var gradientArray = [];

      for (var j = 0; j < intervals.length; j++) {
        var interval = intervals[j];
        var start = interval.lower === 0 ? 1 : Math.ceil(interval.lower);
        var end = interval.upper === maxNum ? interval.upper + 1 : Math.ceil(interval.upper);

        for (var i = start; i < end; i++) {
          gradientArray.push(gradients[j].getColor(i));
        }
      }

      return gradientArray;
    };

    this.getColor = function (props) {
      if (isNaN(props)) {
        throw new TypeError("getColor should be a number");
      } else if (props <= 0) {
        throw new TypeError("getColor should be greater than ".concat(props));
      } else {
        var segment = (maxNum - 0) / gradients.length;
        var index = Math.min(Math.floor((Math.max(props, 0) - 0) / segment), gradients.length - 1);
        return gradients[index].getColor(props);
      }
    };

    this.setMidpoint = function (maxNumber) {
      if (!isNaN(maxNumber) && maxNumber >= 0) {
        maxNum = maxNumber;
        setColors(colors);
      } else if (maxNumber <= 0) {
        throw new RangeError("midPoint should be greater than ".concat(maxNumber));
      } else {
        throw new RangeError('midPoint should be a number');
      }

      return _this;
    };
  }

  return Gradient;
}();

var GradientColor = /*#__PURE__*/function () {
  "use strict";

  function GradientColor() {
    var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var endColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var minNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var maxNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

    _classCallCheck(this, GradientColor);

    this.setGradient = function (colorStart, colorEnd) {
      startColor = getHexColor(colorStart);
      endColor = getHexColor(colorEnd);
    };

    this.setMidpoint = function (minNumber, maxNumber) {
      minNum = minNumber;
      maxNum = maxNumber;
    };

    this.getColor = function (props) {
      if (props) {
        return '#' + generateHex(props, startColor.substring(0, 2), endColor.substring(0, 2)) + generateHex(props, startColor.substring(2, 4), endColor.substring(2, 4)) + generateHex(props, startColor.substring(4, 6), endColor.substring(4, 6));
      }
    };

    var generateHex = function generateHex(number, start, end) {
      if (number < minNum) {
        number = minNum;
      } else if (number > maxNum) {
        number = maxNum;
      }

      var midPoint = maxNum - minNum;
      var startBase = parseInt(start, 16);
      var endBase = parseInt(end, 16);
      var average = (endBase - startBase) / midPoint;
      var finalBase = Math.round(average * (number - minNum) + startBase);
      var balancedFinalBase = finalBase < 16 ? "0" + finalBase.toString(16) : finalBase.toString(16);
      return balancedFinalBase;
    };

    var getHexColor = function getHexColor(props) {
      return props.substring(props.length - 6, props.length);
    };
  }

  return GradientColor;
}();

module.exports = Gradient;